"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ParentLink = exports.LabelWrapper = void 0;
var _uiKit = require("@icis/ui-kit");
var _styledComponents = _interopRequireDefault(require("styled-components"));
const {
  colours,
  spacing
} = _uiKit.theme;
const ParentLink = exports.ParentLink = _styledComponents.default.button.withConfig({
  displayName: "Parentstyle__ParentLink",
  componentId: "sc-10iru9d-0"
})(["display:flex;justify-content:space-between;border-bottom:solid 1px ", " !important;padding:21px 30px 21px 16px;background:none;width:100%;text-align:left;cursor:pointer;&:active{background-color:", ";div{color:", ";}span{color:", ";}svg{path{fill:", ";}}}"], colours.NEUTRALS_5, colours.PRIMARY_1, colours.WHITE, colours.WHITE, colours.WHITE);
const LabelWrapper = exports.LabelWrapper = _styledComponents.default.div.withConfig({
  displayName: "Parentstyle__LabelWrapper",
  componentId: "sc-10iru9d-1"
})(["display:flex;align-items:center;gap:", ";"], spacing.BASE_1);